import { createContext } from 'react';
import { AiChatVariant } from './types';

// AiChatView 하위(특히 Portal 로 렌더되는 툴팁)에서 테마를 알 수 있게 전달.
export const AiChatVariantContext = createContext<AiChatVariant>('light');
